export default {"src":"/_next/static/media/watch-cracked.b6a557bd.svg","height":80,"width":27};